(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('mediaState', mediaState);

    mediaState.$inject = ['$window', '$rootScope', 'mediaStates'];

    function mediaState($window, $rootScope, mediaStates) {
        var result = {},
            state;

        Object.defineProperty(result, 'state', { get: getState });
        Object.values(mediaStates).map(addStateProperty);
        activate();
        return result;

        /////////////////////////////////

        function activate() {
            Object.values(mediaStates.$metadata).forEach(addMedia);

            function addMedia(meta) {
                var query = $window.matchMedia(meta.queryString);
                query.addListener($rootScope.$apply.bind($rootScope, setValue));
                setValue();

                function setValue() {
                    if (query.matches) 
                        state = meta.value;
                }
            }
        }

        function addStateProperty(mediaState) {
            Object.defineProperty(result, mediaState, { get: get });
            function get() { return state === mediaState; }
        }

        function getState() {
            return state;
        }
    }
})();